;(function ($) {
  $.getScript('/api/analytics/mandatory')
    .done(function (script, textStatus) {
      // Empty on purpose
    })
    .fail(function (jqXHR, textStatus) {
      console.warn('/api/analytics request failed: ' + textStatus)
    })
  $.getScript('/api/chat')
})(jQuery, window, document)
